const {Component} = require("react");
const PropTypes = require("prop-types");
const moment = require("moment");
const Pikaday = require("pikaday");
const {classList} = require("helpers/html");
const env = require("services/env");

class Calendar extends Component {

	static get propTypes() {
		return {
			min: PropTypes.string,
			max: PropTypes.string,
			value: PropTypes.string,
			handleChange: PropTypes.func,
			dayClassNameFn: PropTypes.func,
			disableDayFn: PropTypes.func
		}
	}

	normalizeDate(d) {
		return new Date(Date.UTC(
			d.getFullYear(),
			d.getMonth(),
			d.getDate(),
			d.getHours(),
			d.getMinutes(),
			d.getSeconds()
		));
	}

	componentWillReceiveProps(props) {
		// update min & max date
		if (props.min) {
			this.picker.setMinDate(moment(props.min).toDate());
		}

		if (props.max) {
			this.picker.setMaxDate(moment(props.max).toDate());
		}

		if (props.value) {
			this.picker.setDate(this.normalizeDate(moment(props.value).toDate()), true);
		}
	}

	componentDidMount() {
		let options = {};

		options.firstDay = 1;
		options.keyboardInput = false;
		options.yearRange = 100;

		options.onSelect = date => {
			if (typeof this.props.handleChange === "function") {
				this.props.handleChange(moment(date).format("YYYY-MM-DD"));
			}
		};

		if (this.props.min) {
			options.minDate = moment(this.props.min).toDate();
		}

		if (this.props.max) {
			options.maxDate = moment(this.props.max).toDate();
		}

		if (this.props.value) {
			options.defaultDate = this.normalizeDate(moment(this.props.value).toDate());
			options.setDefaultDate = true;
		}

		if (typeof this.props.dayClassNameFn === "function") {
			options.dayClassNameFn = this.props.dayClassNameFn;
		}

		if (typeof this.props.disableDayFn === "function") {
			options.disableDayFn = this.props.disableDayFn;
		}

		if (env.has("options.pikadayLanguage")) {
			options.i18n = env.get("options.pikadayLanguage");
		}

		const picker = this.picker = new Pikaday(options);

		if (this.props.value == null) {
			picker.setDate(null);
		}

		// Append
		this.element.appendChild(picker.el);
	}

	render() {
		return (
			<div ref={el => this.element = el} className={classList("calendar", this.props.className)}></div>
		);
	}

}

module.exports = Calendar;


// WEBPACK FOOTER //
// ./resources/js/components/widgets/Calendar.js